export enum SlotType {
  DOWNLINK = 'D',
  UPLINK = 'U',
  FLEXIBLE = 'F',
}
